module.exports = __webpack_public_path__ + "img/B5.057107a5.svg";